import React from "react";
import imageKeywords from "../imageIndex-sketch.json";
import { createShortDescription } from "../utils/storyParser";

const Card = ({ story, updateImagePickerStory, visible = true }) => {
  const title = (story) => {
    const matches = story.text.match(/^([^:]+):(.*)/);
    return matches ? [matches[1], matches[2]] : [null, story.text];
  };
  
  // Style for faded content
  const fadedStyle = {
    opacity: visible ? 1 : 0.25,
    transition: 'opacity 0.3s ease'
  };

  const imgName = (storyText) => {
    const root = "/screens/";
    const candidates = {};

    if (/#[^\s]+/i.test(storyText)) {
      const imageNames = storyText.match(/#([^\s]+)/);
      const imageName = imageNames[1];
      return `${root}${imageName}.png`;
    } else {
      imageKeywords.forEach((entry) => {
        const keywordsFound = entry.keywords.filter((keyword) => {
          const regex = new RegExp(`\\b${keyword.keyword}\\b`, "i");
          return regex.test(storyText);
        });

        if (!candidates[entry.filename]) candidates[entry.filename] = 0;
        candidates[entry.filename] += keywordsFound.length;
      });

      const sortedArray = Object.entries(candidates).sort(
        (a, b) => b[1] - a[1]
      );
      return sortedArray.length > 0
        ? `${root}${sortedArray[0][0]}`
        : `${root}lock-screen.png`;
    }
  };

  const imgNames = (storyText) => {
    const root = "/screens-clean/";
    const candidates = {};
    var hashtags = [];
    var fullImageNames = [];
    const regex = /#[\w-]+/g;
    if (regex.test(storyText)) {
      const imageNames = storyText.match(regex);

      if (imageNames) {
        hashtags = imageNames.map((tag) => tag.substring(1));

        // console.log(hashtags);
        hashtags.map((foundName) => {
          // console.log(`Adding: ${foundName}`);
          const exactMatches = imageKeywords.filter(
            (k) => k.filename === foundName + ".png"
          );
          exactMatches.forEach((m) => {
            fullImageNames.push(`${root}${m.filename}`);
          });
        });

        //return fullImageNames;
      }
    }
    // if we found an exact match on the hash such as #onboarding then
    // we can just return that
    if (fullImageNames.length > 0) return fullImageNames;
    var tmpStoryText = storyText;

    // otheriwse we'll treat the hash as a keyword and search again
    hashtags.forEach((h) => {
      if (h.length > 2) {
        tmpStoryText += ` ${h}`;
      }
    });

    if (true) {
      imageKeywords.forEach((entry) => {
        entry.keywords.forEach((item) => {
          const regex = new RegExp(`\\b${item.keyword}\\b`, "i");
          if (regex.test(tmpStoryText)) {
            if (!candidates[entry.filename]) candidates[entry.filename] = 0;
            candidates[entry.filename] += item.weight;
          }
        });
        // const keywordsFound = entry.keywords.filter((keyword) =>
        //   storyText.toLowerCase().includes(keyword.keyword)
        // );

        // console.log(keywordsFound ? keywordsFound[0] : '')

        // if (!candidates[entry.filename]) candidates[entry.filename] = 0;

        // candidates[entry.filename] += keywordsFound.length;
      });

      const sortedArray = Object.entries(candidates).sort(
        (a, b) => b[1] - a[1]
      );
      return sortedArray.length > 0
        ? [`${root}${sortedArray[0][0]}`]
        : [`${root}lock-screen.png`];
    }
  };

  const text = (storyText) => {
    return storyText ? storyText.replace(/#[^\s]+/g, "") : storyText;
  };

  const shortText = (storyText) => {
    return storyText ? createShortDescription(storyText.replace(/#[^\s]+/g, "")) : "";
  };

  return (
    <div
      className="flow-card grow"
      style={{ 
        width: story.imageCount * 180 + "px",
        ...fadedStyle
      }}
      id={story.lineNo}
    >
      <div className="columns mb-0">
        {imgNames(`${story.title ?? ""} ${story.text}`).map((imageFile) => (
          <div className="column">
            <img
              src={imageFile}
              alt={story.text}
              className="flow-screen"
              onClick={() => {
                updateImagePickerStory ? updateImagePickerStory(story) : null;
              }}
            />
          </div>
        ))}
      </div>

      <div style={{minHeight: '1rem'}}>
      {story.tags && story.tags.length > 0 && (
          <span className="tags mr-2">
            {story.tags.map(tag => (
              <span key={tag} className="tag is-info is-light is-small">{tag}</span>
            ))}
          </span>
        )}
      </div>
      <h1 className="mt-1">
        {story.title}
        
      </h1>
      <div className="flow-card-label">
        {story.useShortDescription !== false ? (
          <div dangerouslySetInnerHTML={{ __html: shortText(story.text) }}></div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: story.text }}></div>
        )}
      </div>
    </div>
  );
};

export default Card;
